// extracted by mini-css-extract-plugin
export default {"root":"_2XK3sihi","brandingLink":"_2A1AwVaY","logo":"_1jbeTghy","description":"_3MnnEXqm"};